module.exports = __webpack_public_path__ + "img/proof-active.d15f0865.svg";